import {
  USER_LEAVE_FETCHING,
  USER_LEAVE_FAILED,
  USER_LEAVE_SUCCESS,
  LEAVE_TYPE_FETCHING,
  LEAVE_TYPE_FAILED,
  LEAVE_TYPE_SUCCESS,
  LEAVEEMPLOYEES_WITHDRAW_FETCHING,
  LEAVEEMPLOYEES_WITHDRAW_SUCCESS,
  LEAVEEMPLOYEES_WITHDRAW_FAILED,
  LEAVE_3MONTH_FETCHING,
  LEAVE_3MONTH_FAILED,
  LEAVE_3MONTH_SUCCESS,
  LEAVE_YEAR_FETCHING,
  LEAVE_YEAR_FAILED,
  LEAVE_YEAR_SUCCESS,
} from "./types";

import LeaveService from "../services/leave.service";

export const getAllLeaveBalanceByEmployeeId = (year) => async (dispatch) => {
  try {
    const res = await LeaveService.getAllLeaveBalanceByEmployeeId(year);
    if (res) {
      dispatch({
        type: USER_LEAVE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: USER_LEAVE_FAILED,
    });
    return err
  }
};

export const getAllLeaveEmployeesBy = (filter, search) => async (dispatch) => {
  try {
    const res = await LeaveService.getAllLeaveEmployeesBy(filter, search);
    if (res) {
      dispatch({
        type: USER_LEAVE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: USER_LEAVE_FAILED,
    });
    return err
  }
};

export const allLeaveEmployeeByManager = (search) => async (dispatch) => {
  try {
    const res = await LeaveService.allLeaveEmployeeByManager(search);
    if (res) {
      dispatch({
        type: USER_LEAVE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: USER_LEAVE_FAILED,
    });
    return err
  }
};

export const allLeaveType = () => async (dispatch) => {
  try {
    const res = await LeaveService.allLeaveType();
    if (res) {
      dispatch({
        type: LEAVE_TYPE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: LEAVE_TYPE_FAILED,
    });
    return err
  }
};

export const addLeaveType = (formData) => async (dispatch) => {
  try {
    // console.log(formData);
    const res = await LeaveService.addLeaveType(formData);
    if (res) {
      return res
    }
  } catch (error) {
    // console.log(error)
    if (error.response) {
      return error.response;
    }
  }
}

export const deleteLeaveType = (idLeaveType) => async (dispatch) => {
  try {
    // console.log(formData);
    const res = await LeaveService.deleteLeaveType(idLeaveType);
    if (res) {
      return res
    }
  } catch (error) {
    // console.log(error)
    if (error.response) {
      return error.response;
    }
  }
}

export const deleteLeaveGroup = (idLeaveGroup) => async (dispatch) => {
  try {
    // console.log(formData);
    const res = await LeaveService.deleteLeaveGroup(idLeaveGroup);
    if (res) {
      return res
    }
  } catch (error) {
    // console.log(error)
    if (error.response) {
      return error.response;
    }
  }
}

export const addLeaveEmployees = (formData) => async () => {
  try {
    console.log(formData)
    const res = await LeaveService.addLeaveEmployees(formData);
    if (res) {
      return res
    }
  } catch (error) {
    console.log(error)
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error"
  }
};

export const updateApproveLeaveEmployeeBy = (filter, formData) => async () => {
  try {
    const res = await LeaveService.updateApproveLeaveEmployeeBy(filter, formData);
    if (res) {
      return res
    }
  } catch (error) {
    console.log(error)
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error"
  }
};

export const withdrawLeaveEmployee = (filter, formData) => async () => {
  try {
    const res = await LeaveService.withdrawLeaveEmployee(filter, formData);
    if (res) {
      return res
    }
  } catch (error) {
    console.log(error)
    const message =
      (error.response &&
        error.response.data &&
        error.response.data.name) ||
      error.name ||
      error.toString();
    return "Error"
  }
};

export const uploadFileLeaveType = (formData) => async () => {
  try {
    const res = await LeaveService.uploadFileLeaveType(formData);
    if (res) {
      return res.data;
    }
  } catch (error) {
    console.log(error.response)
    if (error.response) {
      return error.response.data;
    }
  }
};

export const getAllLeaveWithDrawBy = (filter, search) => async (dispatch) => {
  try {
    dispatch({
      type: LEAVEEMPLOYEES_WITHDRAW_FETCHING,
    });
    const res = await LeaveService.getAllLeaveWithDrawBy(filter, search);
    if (res) {
      dispatch({
        type: LEAVEEMPLOYEES_WITHDRAW_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: LEAVEEMPLOYEES_WITHDRAW_FAILED,
    });
    console.log(err);
  }
};

export const uploadExcelLeaveEmployees = (formData) => async () => {
  try {
    const res = await LeaveService.uploadExcelLeaveEmployees(formData);
    if (res) {
      return res.data;
    }
  } catch (error) {
    console.log(error.response);
    if (error.response) {
      return error.response.data;
    }
  }
};

export const getExcelDataLeaveTypeEmployee = () => async () => {
  try {
    const res = await LeaveService.getExcelDataLeaveTypeEmployee();
    if (res) {
      return res.data;
    }
  } catch (error) {
    console.log(error.response);
    if (error.response) {
      return error.response.data;
    }
  }
};

export const getAllLeaveEmployee3month = (start, end,id) => async (dispatch) => {
  try {
    dispatch({
      type: LEAVE_3MONTH_FETCHING,
    });
    const res = await LeaveService.getAllLeaveEmployee3month(start, end,id);
    if (res) {
      dispatch({
        type: LEAVE_3MONTH_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: LEAVE_3MONTH_FAILED,
    });
    console.log(err);
  }
};

export const getAllLeaveEmployeeYear = (start,id) => async (dispatch) => {
  try {
    dispatch({
      type: LEAVE_YEAR_FETCHING,
    });
    const res = await LeaveService.getAllLeaveEmployeeYear(start,id);
    if (res) {
      dispatch({
        type: LEAVE_YEAR_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: LEAVE_YEAR_FAILED,
    });
    console.log(err);
  }
};

export const getAllemployeeAbsentYear = (start,id) => async (dispatch) => {
  try {
    dispatch({
      type: LEAVE_YEAR_FETCHING,
    });
    const res = await LeaveService.getAllemployeeAbsentYear(start,id);
    if (res) {
      dispatch({
        type: LEAVE_YEAR_SUCCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    dispatch({
      type: LEAVE_YEAR_FAILED,
    });
    console.log(err);
  }
};

export const getAllLeaveV2 = () => async (dispatch) => {
  try {
    dispatch({
      type: LEAVE_TYPE_FETCHING,
    });
    const res = await LeaveService.getAllLeaveV2();
    if (res) {
      dispatch({
        type: LEAVE_TYPE_SUCCESS,
        payload: res.data,
      });
      return res;
    }
  } catch (err) {
    dispatch({
      type: LEAVE_TYPE_FAILED,
    });
    return err
  }
};

export const addLeaveQuota = (formData) => async () => {
  try {
    const res = await LeaveService.addLeaveQuota(formData);
    if (res) {
      return res
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    }
  }
}

export const updateLeaveQuota = (idLeaveQuota, formData) => async () => {
  try {
    const res = await LeaveService.updateLeaveQuota(idLeaveQuota, formData);
    if (res) {
      return res
    }
  } catch (error) {
    if (error.response) {
      return error.response;
    }
  }
}

